import { ICauHoiImportRequest } from "../../../model/request/cau-hoi/ICauHoiImportRequest";
import { ICauHoiSelectRequest } from "../../../model/request/cau-hoi/ICauHoiSelectRequest";
import { ISMT_Question_Answer } from "../../../model/respone/cau-hoi/ISMT_Question_Answer";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { ICauHoiActionTypes } from "../../action-types/cau-hoi/ICauHoiActions";
import { ICauHoiReducer } from "../../reducer-model/cau-hoi/ICauHoiReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: ICauHoiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  idSelections: [],
  request: {
    page_index: 0,
    page_size: 50,
  } as ICauHoiSelectRequest,
  cauHois: {
    data: [],
    page_count: 0,
    page_number: 0,
    page_size: 50,
    total_count: 0,
  } as IPagingResult<ISMT_Question_Answer[]>,
  cauHoiEditing: {} as ISMT_Question_Answer,
  requestImport: {} as ICauHoiImportRequest,
  duplicateData: {},
  tongHops: [],
  statusTongHop: eReducerStatusBase.is_not_initialization,
  requestTongHop: {
    id_bm: 0,
    id_mon: 0,
    id_he: 0,
  },
};

export const cauHoiReducer = (
  state: ICauHoiReducer = iniState,
  action: ICauHoiActionTypes,
): ICauHoiReducer => {
  switch (action.type) {
    case "CAU_HOI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        cauHois: {
          data: [],
          page_count: 0,
          page_number: 0,
          page_size: 0,
          total_count: 0,
        } as IPagingResult<ISMT_Question_Answer[]>,
      };
    case "CAU_HOI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        cauHois: action.payload,
        idSelections: [],
        request: {
          ...state.request,
          page_index: action.payload.page_number,
          page_size: action.payload.page_size,
        },
      };
    case "CAU_HOI_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CAU_HOI_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "CAU_HOI_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "CAU_HOI_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CAU_HOI_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "CAU_HOI_DELETE_SUCCESS":
      return {
        ...state,
        idSelections: [],
        status: eReducerStatusBase.is_need_reload,
      };
    case "CAU_HOI_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CAU_HOI_DELETES_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "CAU_HOI_DELETES_SUCCESS":
      return {
        ...state,
        idSelections: [],
        status: eReducerStatusBase.is_need_reload,
      };
    case "CAU_HOI_DELETES_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CAU_HOI_SHOW_EDIT_MODAL":
      return {
        ...state,
        cauHoiEditing: action.payload,
        isShowEditModal: true,
      };
    case "CAU_HOI_CLOSE_EDIT_MODAL":
      return {
        ...state,
        cauHoiEditing: undefined,
        isShowEditModal: false,
      };
    case "CAU_HOI_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "CAU_HOI_SHOW_VIEW_MODAL":
      return {
        ...state,
        cauHoiViewing: action.payload,
        isShowViewModal: true,
      };
    case "CAU_HOI_CLOSE_VIEW_MODAL":
      return {
        ...state,
        cauHoiViewing: undefined,
        isShowViewModal: false,
      };
    case "CAU_HOI_CHANGE_REQUEST":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        request: {
          ...state.request,
          ...action.payload,
        },
      };
    case "CAU_HOI_IMPORT_WORD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_importing,
        isShowProcessing: true,
        htmlError: "",
        processId: action.payload.process_id,
      };
    case "CAU_HOI_IMPORT_WORD_SUCCESS":
      return {
        ...state,
        isShowUploadModal: false,
        htmlError: "",
        status: eReducerStatusBase.is_imported,
        requestImport: {} as ICauHoiImportRequest,
      };
    case "CAU_HOI_IMPORT_WORD_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        htmlError: action.payload,
        isShowUploadModal: false,
        isShowProcessing: false,
      };
    case "CAU_HOI_SHOW_UPLOAD_MODAL":
      return {
        ...state,
        isShowUploadModal: true,
      };
    case "CAU_HOI_CLOSE_UPLOAD_MODAL":
      return {
        ...state,
        isShowUploadModal: false,
        requestImport: {} as ICauHoiImportRequest,
      };
    case "CAU_HOI_SHOW_UPLOAD_FILE_MODAL":
      return {
        ...state,
        isShowUploadFileModal: true,
      };
    case "CAU_HOI_CLOSE_UPLOAD_FILE_MODAL":
      return {
        ...state,
        isShowUploadFileModal: false,
      };
    case "CAU_HOI_CHECK_DUPLICATE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "CAU_HOI_CHECK_DUPLICATE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        duplicateData: action.payload,
      };
    case "CAU_HOI_CHECK_DUPLICATE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CAU_HOI_SHOW_DUPLICATE_MODAL":
      return {
        ...state,
        isShowDuplicateModal: true,
      };
    case "CAU_HOI_CLOSE_DUPLICATE_MODAL":
      return {
        ...state,
        isShowDuplicateModal: false,
      };

    case "CAU_HOI_IMPORT_WORD_CHANGE_REQUEST":
      return {
        ...state,
        requestImport: {
          ...state.requestImport,
          ...action.payload,
        },
      };
    case "CAU_HOI_IMPORT_WORD_CLOSE_PROCESSING_MODAL":
      return {
        ...state,
        isShowProcessing: false,
      };
    case "CAU_HOI_SHOW_SEARCH_MODAL":
      return {
        ...state,
        isShowSearchModal: true,
      };
    case "CAU_HOI_CLOSE_SEARCH_MODAL":
      return {
        ...state,
        isShowSearchModal: false,
      };
    case "CAU_HOI_CLOSE_ERROR_RESULT_IMPORT_MODAL":
      return {
        ...state,
        htmlError: "",
      };
    case "CAU_HOI_LOAD_TONGHOP_START":
      return {
        ...state,
        statusTongHop: eReducerStatusBase.is_loading,
      };
    case "CAU_HOI_LOAD_TONGHOP_SUCCESS":
      return {
        ...state,
        statusTongHop: eReducerStatusBase.is_completed,
        tongHops: action.payload,
      };
    case "CAU_HOI_LOAD_TONGHOP_ERRR":
      return {
        ...state,
        statusTongHop: eReducerStatusBase.is_completed,
      };
    case "CAU_HOI_CHANGE_REQUEST_TONGHOP":
      return {
        ...state,
        statusTongHop: eReducerStatusBase.is_need_reload,
        requestTongHop: {
          ...state.requestTongHop,
          ...action.payload,
        },
      };
    case "CAU_HOI_PROGRESS_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "CAU_HOI_PROGRESS_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        duplicateData: action.payload,
      };
    case "CAU_HOI_PROGRESS_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CAU_HOI_CHANGE_SU_DUNG_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "CAU_HOI_CHANGE_SU_DUNG_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "CAU_HOI_CHANGE_SU_DUNG_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_deleted,
      };
    default:
      return state;
  }
};
